import React from 'react';
import { useQuery } from 'react-query';
import Select, { SelectProps } from 'antd/lib/select';

import { getParametersFilteringList } from 'services/parametersService';
import { Parameter } from 'types';

export type ParametersListSelectProps = SelectProps<any> & {
  filtermode?: string;
  partype?: string;
  parcode?: string;
  parlabel?: string;
};

const ParametersListSelect = ({
  filtermode,
  partype,
  parcode,
  parlabel,
  ...props
}: ParametersListSelectProps) => {
  const { data } = useQuery(
    ['getParametersFilteringList', { filtermode, partype, parcode, parlabel }],
    () => {
      return getParametersFilteringList({
        filtermode: filtermode ?? 'ALL',
        partype: partype ?? '',
        parcode: parcode ?? '',
        parlabel: parlabel ?? '',
      }).then((res: any) => res);
    },
    {
      staleTime: MINUTE,
    }
  );

  return (
    <Select {...props} allowClear>
      {data?.list?.map((parameter: Parameter) => (
        <Select.Option
          value={String(parameter.parcode)}
          key={parameter.parcode}
        >
          {parameter.parlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParametersListSelect;
